import React, { ReactNode } from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact, {
  BugsnagPluginReactResult,
} from "@bugsnag/plugin-react";
import { Fallback } from "../../../pages";

interface IBugsnagProviderProps {
  children: ReactNode;
}

export const BugsnagProvider = ({
  children,
}: IBugsnagProviderProps): JSX.Element => {
  if (import.meta.env.DEV) {
    return <>{children}</>;
  } else {
    Bugsnag.start({
      apiKey: import.meta.env.REACT_APP_BUGSNAG_API_KEY as string,
      plugins: [new BugsnagPluginReact()],
      releaseStage: import.meta.env.REACT_APP_NODE_ENV,
    });

    // Should be fixed with new types from bugsnag
    const ErrorBoundary: any = (
      Bugsnag.getPlugin("react") as BugsnagPluginReactResult
    ).createErrorBoundary(React);

    // Bugsnag.notify(new Error('Test error'))

    return (
      <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>
    );
  }
};

BugsnagProvider.displayName = "BugsnagProvider";
